'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { app } from '../lib/firebase';
export default function FirebaseAnalytics() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
  return null;
}
function _temp2() {
  const initAnalytics = _temp;
  const timer = setTimeout(initAnalytics, 1000);
  return () => clearTimeout(timer);
}
async function _temp() {
  if (typeof window !== "undefined" && (await isSupported())) {
    getAnalytics(app);
  }
}